import { ViewModel,View } from "binder"
import { SearchableSelectorBaseViewModel } from "src/common/reusableComponents/searchableSelectorBase/searchableSelectorBase-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";

export class PersonnelSearchViewModel extends SearchableSelectorBaseViewModel<personnel>{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    
    private shallSearch():boolean{
        return true;
    }
    protected async loadData(searchedText: string): Promise<personnel[]> {
        if(this.shallSearch()==false)
            return [];
        let result = await ServerConnection.callServer('/Complex/PersonnelManipulationServices/SearchOrFindPersonnel',{
            SearchText:searchedText,
            ResultCount:20,
        });
        return result.Personnel.map(x=>this.convert(x));
    }
    protected async loadById(id: string): Promise<personnel> {
        if(this.shallSearch()==false)
            return null;
        let result = await ServerConnection.callServer('/Complex/PersonnelManipulationServices/SearchOrFindPersonnel',{
            Id:id,
        });
        return this.convert(result.Personnel[0]);

    }
    private convert(dto:any):personnel{
        if(dto==null){
            return null;
        }else{
            let result = new personnel(this);
            result.id = dto.Id;
            result.name = dto.Name;
            result.lastName = dto.LastName;
            result.nationalCode = dto.NationalCode;
            result.code = dto.PersonnelCode;
            result.title = `${result.name} ${result.lastName} (${result.code})`;
            return result;
        }
    }    
}

export class personnel extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set lastName(v: string) { this._lastName = v; } public get lastName(): string { return this._lastName;} private _lastName: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set nationalCode(v: string) { this._nationalCode = v; } public get nationalCode(): string { return this._nationalCode;} private _nationalCode: string;
    
}
